/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Signal_Tech_TitleInputs */

const en_landing_signal_tech_title = /** @type {(inputs: Landing_Signal_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semis pre-earnings review`)
};

/**
* | output |
* | --- |
* | "Semis pre-earnings review" |
*
* @param {Landing_Signal_Tech_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_signal_tech_title = /** @type {((inputs?: Landing_Signal_Tech_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Signal_Tech_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_signal_tech_title(inputs)
});